export const clearLocalStorage = () => {
  localStorage.removeItem("session-start");
  localStorage.removeItem("userPhotoPath");
  localStorage.removeItem("userIconPath");
};
